import React, {useContext, useEffect, useState} from 'react';;
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import {PaymentAccountPubKeyContext} from "../../containers/InitCheckoutContainer";
import {ToggleButton, ToggleButtonVariants} from "../ToggleButton";
import {Menu} from "../Menu";
import {paymentSelectorRowWidth} from "../../constants";
import {insertIntoArray} from "../../utils";

const ICONS = {
  checkout: '/assets/images/icons/checkout.svg',
  wechat_pay: '/assets/images/icons/wechatpay.svg',
  alipay: '/assets/images/icons/alipay.svg',
  giropay: '/assets/images/icons/giropay.svg',
  evypay: '/assets/images/icons/evypay.svg',
  p24: '/assets/images/icons/przelewy24.svg',
  ideal: '/assets/images/icons/ideal-wero.svg',
  sofort: '/assets/images/icons/sofort.svg',
  tamara: '/assets/images/icons/tamara.svg',
  bancontact: '/assets/images/icons/bancontact.svg',
  multibanco: '/assets/images/icons/multibanco.svg',
  eps: '/assets/images/icons/eps.svg',
  alipay_cn: '/assets/images/icons/alipay.svg',
  postfinance: '/assets/images/icons/postfinance.svg',
  paypal: '/assets/images/icons/paypal.svg',
};

const PaymentSystemCurrency = ({currency}) => {
    return (
        <i style={{
          fontStyle:'normal',
          background:'var(--clr_subwhite)',
          width:'16px',
          height:'16px',
          justifyContent: 'center',
          display:'inline-flex',
          marginLeft: 'auto',
          borderRadius:'50%',
          fontWeight: 600,
          position: 'absolute',
          top: '50%',
          right: '7px',
          transform: 'translateY(-50%)',
        }}>{currency}</i>);
}

const additionalElementsByPaymentSystem = {
  evypay: <PaymentSystemCurrency currency="₽" />,
}

const PaymentSystemSelector = ({currentPaymentSystem, setCurrentPaymentSystem, paymentSystems}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [paymentSystemList, setPaymentSystemList] = useState(paymentSystems || []);

  useEffect(() => {
    setPaymentSystemList(paymentSystems || []);
  }, [paymentSystems]);

  useEffect(() => {
    updatePaymentSystemList();
  }, [currentPaymentSystem]);

  const updatePaymentSystemList = () => {
    if (!paymentSystems) {
      return;
    }
    if (paymentSystems.length <= paymentSelectorRowWidth || !currentPaymentSystem) {
      return;
    }

    const selectedIndex = paymentSystemList.map(x => x.code).indexOf(currentPaymentSystem.code);
    if (selectedIndex < paymentSelectorRowWidth) {
      return;
    }
    let tempPaymentSystems = [...paymentSystems];
    const itemIndex = tempPaymentSystems.map(x => x.code).indexOf(currentPaymentSystem.code);
    tempPaymentSystems.splice(itemIndex, 1);
    tempPaymentSystems = insertIntoArray(tempPaymentSystems, 2, currentPaymentSystem);
    setPaymentSystemList(tempPaymentSystems);
  }

  const isEvyPayAvailable = paymentSystemList?.find((item) => item.code === 'evypay');

  const namesByPaymentSystem = {
    checkout: isEvyPayAvailable ? t('international_payment') : t('Card'),
    wechat_pay: t('WeChat_Pay'),
    alipay: t('Ali_Pay'),
    giropay: t('Giropay'),
    evypay: t('EvyPay'),
    p24: t('Przelewy24'),
    ideal: t('IDeal'),
    sofort: t('Sofort'),
    tamara: t('Tamara'),
    bancontact: t('Bancontact'),
    multibanco: t('Multibanco'),
    eps: t('EPS'),
    alipay_cn: t('Alipay_CN'),
    postfinance: t('PostFinance'),
    paypal: t('PayPal'),
  }

  const { setPaymentAccountPubKey } = useContext(PaymentAccountPubKeyContext)
  const [isMenuOpened, setIsMenuOpened] = useState(false)

  const handleChange = (event, value) => {
    if (currentPaymentSystem.code === value || !value)
      return;
    const paymentSystem = paymentSystems.find((item) => item.code === value);
    setCurrentPaymentSystem(paymentSystem);
    setPaymentAccountPubKey(paymentSystem.key);
  };

  const rowPaymentSystems = paymentSystemList?.slice(0, Math.min(paymentSelectorRowWidth, paymentSystemList?.length))
  const menuPaymentSystems = paymentSystemList?.slice(paymentSelectorRowWidth, paymentSystemList?.length)

  return paymentSystemList?.length > 1 ? (
      <div className={`${classes.wrapper}`}>
          <div className={`${classes.grouped}`}>
              {rowPaymentSystems?.map((item) => (
                  <ToggleButton
                      key={item.code}
                      onSelect={() => handleChange(null, item.code)}
                      isSelected={currentPaymentSystem.code === item.code}
                  >
                      <>
                          <img className={classes.icon} src={ICONS[item.code]} alt={item.code} />
                          <div className={`${classes.label} pay_method_text`}>{namesByPaymentSystem[item.code]}</div>
                          {additionalElementsByPaymentSystem[item.code] && additionalElementsByPaymentSystem[item.code]}
                      </>
                  </ToggleButton>
              ))}
              {
                  menuPaymentSystems?.length > 0 && (
                      <Menu
                          isOpened={isMenuOpened}
                          menuActivator={
                              <ToggleButton
                                  onSelect={() => setIsMenuOpened(!isMenuOpened)}
                                  variant={ToggleButtonVariants.More}
                              >
                                  <>
                                      {
                                          new Array(3)
                                              .fill(0)
                                              .map((_, index) => (<span key={`more-${index}`}></span>))
                                      }
                                  </>
                              </ToggleButton>
                          }
                          onChange={(v) => setIsMenuOpened(v)}
                      >
                          {menuPaymentSystems?.map((item) => (
                              <ToggleButton
                                  key={item.code}
                                  onSelect={() => {
                                      handleChange(null, item.code)
                                      setIsMenuOpened(false)
                                  }}
                                  isSelected={currentPaymentSystem.code === item.code}
                                  variant={ToggleButtonVariants.Row}
                              >
                                  <>
                                      <img className={classes.iconSmall} src={ICONS[item.code]} alt={item.code}/>
                                      <div
                                          className={`${classes.label} pay_method_text`}>{namesByPaymentSystem[item.code]}</div>
                                      {additionalElementsByPaymentSystem[item.code] && additionalElementsByPaymentSystem[item.code]}
                                  </>
                              </ToggleButton>
                          ))}
                      </Menu>
                  )
              }
          </div>
      </div>
  ) : null;
};

export default PaymentSystemSelector;
